// import addressData from './assets/data/address.json'; // Plan 3: nạp runtime qua SysAddress — bỏ 1.8MB khỏi bundle
// import categoryData from "./assets/data/category.json";

export default {
    addressData: [],
    categoryData: [] // categoryData,
};
